export const ITA_NAV = [
  { k: "dashboard",   l: "Dashboard",    i: "dash" },
  { k: "analytics",   l: "Analytics",    i: "chart" },
  { k: "assets",      l: "Assets",       i: "bulk" },
  { k: "credentials", l: "Credentials",  i: "shield" },
  { k: "people",      l: "People",       i: "people" },
  { k: "requests",    l: "Requests",     i: "req" },
  { k: "exit",        l: "Exit Process", i: "exit" },
  { k: "logs",        l: "Action Logs",  i: "log" },
  { k: "announce",    l: "Announcements", i: "announce" },
  { k: "calendar",    l: "Calendar",     i: "calendar" },
  { k: "notes",       l: "Notes",        i: "note" },
  { k: "notifications", l: "Notifications", i: "bell" },
  { k: "chat",        l: "Chat",         i: "send" },
];
